import {Helmet} from '@dr.pogodin/react-helmet';
import {openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {useDeleteConfigurationPaymentImportModeMutation} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['branch_name'] as const;

export function TaxDocumentImportTypeOverview() {
  const navigate = useNavigate();
  const [deleteTypeTypeDefinition] = useDeleteConfigurationPaymentImportModeMutation();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    refreshData,
    getColumnData,
  }) => {
    const branchId = isArray(rowId) ? rowId[0] : rowId;
    const branchName = getColumnData<string>('branch_name')?.value;

    match(actionKey)
      .with('redirectDetail', 'edit', () =>
        navigate(composePath(settingsRoutes.taxDocumentImportTypeDetail, {params: {branchId}}))
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteTypeTypeDefinition({branchId})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
          text: i18n.t('entity.accounting.labels.deleteDefinitionDeleteText', {
            name: branchName,
          }),
        })
      );
  };

  const title = i18n.t('page.accountingSettings.labels.importType');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{
          title,
          actions: [
            {
              type: 'button',
              title: i18n.t('page.accounting.labels.newDefinition'),
              onClick: () => navigate(settingsRoutes.taxDocumentImportTypeNew),
            },
          ],
        }}
        description={i18n.t('page.accountingSettings.labels.importTypeDescription')}
        data-testid={testIds.settings.taxDocumentImportType('page')}
      >
        <DmsDataGrid
          gridCode="payment-import-mode"
          actionCallback={actionCallback}
          predefinedColumns={PREDEFINED_COLUMNS}
          data-testid={testIds.settings.taxDocumentImportType('datagrid')}
        />
      </SettingsTemplate>
    </>
  );
}
